<template>
  <div class="home">
    <Menu :show="showMenu"></Menu>
    <div :style="'height:1015px;width: 100%;min-width: 1244px;z-index: 2;position: absolute;opacity: 0.71;background-image: linear-gradient(180deg, #000000 0%, rgba(1,1,0,0.88) 15%, rgba(8,7,1,0.00) 100%);'"></div>
    <div :style="'height:1015px;width: 100%;min-width: 1244px;z-index: 2;position: absolute;'" class="banner_zindex">
      <div>
        <img class="block-text logo-img" src="./../assets/img/icon_guanggao_home.png" alt="">
        <img class="block-text logo-button" src="./../assets/img/btn_tap_home_btn.png" @click="toRoom()" alt="">
        <img class="taps banner-img" src="./../assets/img/icon_taps_home.png" alt="">
        <div class="banner-text"><span class="ve-line"></span></div>
        
      </div>
    </div>
    <div class="banner__wrapper" :style="'height:1015px'">
      <div class="banner__inner" :style="'height:1015px'">
        <div class="banner-img__wrapper" :style="'height:1015px'">
          <img class="smallImg" src="./../assets/img/img_bg1_home.png">
          <img style="width: 100%;min-height: 760px"  :height=" 1015 + 'px'" src="http://www.lvshouhotel.com/lvshouhotel/img_bg_home.jpg">
        </div>
      </div>
    </div>
    <div class="channel__wrapper">
      <div class="channel__inner">
        <div class="channel-img__wrapper">
          <img style="width:100%;" src="./../assets/img/Img-diwen-home.png" alt="">
          
        </div>
      </div>
    </div>
    
    <div style="min-height: 828px;" v-show="!showbrand"></div>
    <div class="box brand" style="min-height: 828px; " v-show="showbrand">
      <div class="box-title">
        <img class="block-text" src="./../assets/img/icon_pingpailiaojie_home.png" alt="">
      </div>
      <!-- <div class="title-en ta_c block-text">OUR BRAND</div>
      <div class="title ta_c block-text">品牌了解</div> -->
      <div class="brand__inner">
        <img class="fl brand-img" width="639" src="http://www.lvshouhotel.com/lvshouhotel/img_hotle_home_brand.png" alt=""> 
        <div class="fr brand__wrapper">
          <h1 class="ta_c brand-text">绿瘦酒店</h1>
          <h3 class="brand-text">在宁谧的环境下，感受城市与旅游胜地的惬意风</h3>
          <h3 class="brand-text">光，享受绿瘦酒店带给您的超凡服务。</h3>
          <ul class="brand-text">
            <li>步行五分钟抵达地铁12号线七莘路站</li>
            <li>最大1200平米宴会厅满足近千人次会议需求</li>
            <li>距虹桥高铁站及虹桥机场15分钟车程，20分钟车程直达国家会展中</li>
          </ul>
          <button class="btn brand-text" @click="setUrl('/Brand')">了解更多</button>
        </div>
      </div>
    </div>
    <div style="min-height: 1382px;" v-show="!showroom"></div>
    <div class="box room" v-show="showroom">
      <div class="box-title">
        <img class="block-text" src="./../assets/img/icon_tuijfangjian_home.png" alt="">
      </div>
      <h3 class="brand-text" style="margin-top: 60px;">上海绿瘦酒店拥有豪华房及套房共265间，设有管家服务、客房送餐服务、礼宾服务、洗衣服务及多</h3>
      <h3 class="brand-text">国语言翻译服务，能满足您商务与休闲的不同需求。高雅、气派的房间设计氛围令人倍感温馨和舒</h3>
      <div class="room__inner">
        <div class="o_v">
          <div class="fl p_r">
            <div class="room__img brand-img">
              <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide><img src="http://www.lvshouhotel.com/lvshouhotel/img_rooma_home.png" alt="商务及行政套房,商务及行政套房宽敞明亮，豪华舒适，一应俱全的设施包括现代雅致的独立会客厅，入住并可饱览窗外繁华的都市风光。无论是商务出行还是休闲旅游，宾客都将享受绿瘦酒店与众不同的待客之道。"></swiper-slide>
                <swiper-slide><img src="http://www.lvshouhotel.com/lvshouhotel/img_rooma_home2.jpg" alt="商务及行政套房,商务及行政套房宽敞明亮，豪华舒适，一应俱全的设施包括现代雅致的独立会客厅，入住并可饱览窗外繁华的都市风光。无论是商务出行还是休闲旅游，宾客都将享受绿瘦酒店与众不同的待客之道。"></swiper-slide>
              </swiper>
            </div>
            <div class="room__shaw brand-img">
              <h2>商务及行政套房</h2>
              <p>商务及行政套房宽敞明亮，豪华舒适，一应俱全的设施包括现代雅致的独立会客厅，入住并可饱览窗外繁华的都市风光。无论是商务出行还是休闲旅游，宾客都将享受绿瘦酒店与众不同的待客之道。</p>
            </div>
          </div> 
          <div class="fr p_r">
            <div class="room__img_mini brand-img">
              <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide><img src="http://www.lvshouhotel.com/lvshouhotel/img_roomb_home.png"  alt="行政房,行政客房装饰优雅现代，宽敞舒适，入住宾客还可尊享专属礼遇。时尚的客房采用丰富的对比色调，是追求额外个性化周到服务旅客的理想之选。"></swiper-slide>
                <swiper-slide><img src="http://www.lvshouhotel.com/lvshouhotel/img_roomb_home2.jpg" alt="行政房,行政客房装饰优雅现代，宽敞舒适，入住宾客还可尊享专属礼遇。时尚的客房采用丰富的对比色调，是追求额外个性化周到服务旅客的理想之选。"></swiper-slide>
              </swiper>
            </div>
            <div class="room__shaw_mini brand-img">
              <h2>行政房</h2>
            </div>
          </div>
          <div class="fr p_r" style="margin-top: 16px;">
            <div class="room__img_mini brand-img">
              <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide><img src="http://www.lvshouhotel.com/lvshouhotel/img_roomc_home.png" alt="商务房,商务客房采用现代时尚的设计风格，宾客可透过明亮宽敞的窗户眺望上海城市景致，温馨的灯光和室内装饰为入住并可打造一片休闲或工作的舒适空间。"></swiper-slide>
                <swiper-slide><img  src="http://www.lvshouhotel.com/lvshouhotel/img_roomc_home.png" alt="商务房,商务客房采用现代时尚的设计风格，宾客可透过明亮宽敞的窗户眺望上海城市景致，温馨的灯光和室内装饰为入住并可打造一片休闲或工作的舒适空间。"></swiper-slide>
              </swiper>
            </div> 
            <div class="room__shaw_mini brand-img">
              <h2>商务房</h2>
            </div>
          </div>
        </div>
        <div class="dots"></div>
       
      </div>
      
      <button class="btn" @click="toRoom()">了解更多</button>
    </div>
    <div style="min-height: 830px;" v-show="!showmeeting"></div>
    <div class="box meeting" v-show="showmeeting">
      <div class="box-title">
        <img class="block-text" src="./../assets/img/icon_huiyiyuyanhui_home.png" alt="">
      </div>
      <div class="meeting__inner">
        <div class="fl meeting__wrapper">
          <h3 class="brand-text" style="margin-top: 60px;">从优美的环境到一应俱全的商业设备，将您每</h3>
          <h3 class="brand-text">一次的会议与宴会交给我们策划，能助您打造</h3>
          <h3 class="brand-text">愉快与充满成效的难忘活动体验。</h3>
          <p class="brand-text">绿瘦酒店从40平米的小会议室到1200平米无柱型宴会厅，都可满足各种规模的商务和休闲活动。</p>
          <button class="btn brand-text" @click="setUrl('/conferencesAndBanquets')">了解更多</button>
        </div>
        <img class="fl brand-img" width="639" height="503" src="http://www.lvshouhotel.com/lvshouhotel/img_yanhui_home.png" alt=""> 
      </div>
    </div>
    <div style="min-height: 1034px;" v-show="!showcele"></div>
    <div class="box celebration" v-show="showcele">
      <div class="box-title">
        <img class="block-text" src="./../assets/img/icon_hunyanyuqingdian_home.png" alt="">
      </div>
      <div class="celebration__inner">
        <div class="cel__box ">
          <p class="brand-text">绿瘦酒店将根据您的不同需求，个性化定制专属婚礼</p>
          <p class="brand-text">用心设计每个细节，让您轻松享受婚礼甜蜜和浪漫。</p>
        </div>
        <img class="brand-img" src="http://www.lvshouhotel.com/lvshouhotel/img_hunyan_home.png" alt=""> 
      </div>
    </div>
    <div class="box address">
      <div class="box-title">
        <img class="block-text" src="./../assets/img/icon_mudidi_home.png" alt="">
      </div>
      <div class="address__inner">
        <div class="line_left fl"></div>
        <div class="line_right fr"></div>
      </div>
      <div class="map">
        <div class="map-layer">
          <div class="map-layer-tabs">
            <div class="tabs-wrap o_v">
              <div class="tab-item fl" v-for="(item, index) in tabList" :class="index == selectNum ? 'tab-item-on' : ''" @click.prevent="tabSelect(index)" :key="index">{{item.tab}}</div>
            </div>
            <div class="options-lists">
              <div class="option">
                <ul>
                  <li class="js-map-option o_v" v-for="(item, index) in tabList[selectNum].list" :class="index === optionNum ? 'clicked' : ''" @click="optionSeltct(index)" :key="index">
                    <div class="option-index fl">{{index + 1}}</div>
                    <div class="option-cont fl">
                      <div class="option-tit">{{item.name}}</div>
                      <p><span class="text-medium text-desc">{{item.medium}}</span>公里</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div id="map__inner"></div>
      </div>
    </div>
    <!-- 放大图片弹窗插件 -->
    <EnlargeImg :show="imgShow" :item="item" @isclose="close"></EnlargeImg>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import Menu from '@/components/common/menu'
import EnlargeImg from "@/components/common/enlargeImg";

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { close } from 'fs';
let vm = null;
export default {
  name: 'home',
  data() {
    return {
      tabList: [
        {
          tab: "火车站",
          list: [
            {
              name: "上海站",
              LatLng: [31.249563, 121.455739],
              medium: "22.80"
            },
            {
              name: "上海南站",
              LatLng: [31.153182, 121.429115],
              medium: "10.20"
            },
            {
              name: "虹桥火车站",
              LatLng: [31.193987, 121.320038],
              medium: "10.00"
            }
          ]
        },
        {
          tab: "飞机场",
          list: [
            {
              name: "浦东国际机场",
              LatLng: [31.149686, 121.806622],
              medium: "49.60"
            },
            {
              name: "上海虹桥国际机场",
              LatLng: [31.196056, 121.339785],
              medium: "9.60"
            }
          ]
        },
        {
          tab: "地铁",
          list: [
            {
              name: "七莘路站",
              LatLng: [31.1315900000,121.3623930000],
              medium: "0.80"
            }
          ]
        },
      ],
      selectNum: 0,
      optionNum: "",
      showbrand: false,
      showroom: false,
      showmeeting: false,
      showcele: false,
      map:  {},
      markerLayer:  {},
      bannerHeight: 0,
      showMenu: false,
      imgShow: false,
      item: {},
      swiperOption: {
        autoplay:  {
          delay: 4000,
          stopOnLastSlide: true,
          disableOnInteraction: false,
        },
        loop : true,
        effect : 'slide',
        pagination: {
          el: '.dots',
          clickable :true
        },
        on:{
          click: function(e){
            console.log(e)
            vm.imgShow = true;
            vm.item = { url: e.toElement.currentSrc, name: e.toElement.alt.split(',')[0], desc: e.toElement.alt.split(',')[1]}
          },
        },
      },
      
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  components: {
    swiper,
    swiperSlide,
    Menu,
    EnlargeImg
  },
  mounted() {
    vm = this;
    this.bannerHeight = document.documentElement.offsetHeight;
    window.addEventListener('scroll', this.scroll)
    this.$nextTick(() => {
      var center = new TMap.LatLng(31.249563, 121.455739)
      this.map = new TMap.Map(document.getElementById('map__inner'), {
          center: center,
      });
      this.initMap()
    })
  },
  methods: {
    close(){
      this.imgShow = false;
      this.item = { url: "", name: "", desc: ""}
    },
    setUrl(url) {
      //导航菜单跳转路由方法
      this.$router.push(url);
    },
    toRoom(){
      let routeUrl = this.$router.resolve({
            path: "/room",
      });
      window.open(routeUrl .href, '_blank');
    },
    scroll(){
      var scroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (scroll >= this.bannerHeight - 290 + 56) {
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
      if (scroll >= 887) {
        this.showbrand = true;
      }
      if(scroll >= 1710){
        this.showroom = true;
      }
       if(scroll >= 3415 ){
        this.showmeeting = true;
      }
      if(scroll >= 4329){
        this.showcele = true;
      }
    },
    tabSelect(num){
      this.selectNum = num;
      this.optionNum = "";
    },
    optionSeltct(num){
      this.optionNum = num;
      this.setMap();
    },
    setMap(){
      var latlng = this.tabList[this.selectNum].list[this.optionNum].LatLng;
      this.tabList.map((item, pIndex) => {
        item.list.map((row, index) => {
          let i = index + 1;
          if (pIndex == this.selectNum && this.optionNum == index) {
            this.markerLayer.updateGeometries([
              {
                "styleId": "myStyle" + i + "on",
                "id": this.selectNum + 1 + "" + this.optionNum,
                "position": new TMap.LatLng(latlng[0], latlng[1]),
              }
            ])
          } else {
            this.markerLayer.updateGeometries([
              {
                "styleId": "myStyle" + i,
                "id": pIndex + 1 + "" + index,
                "position": new TMap.LatLng(row.LatLng[0], row.LatLng[1]),
              }
            ])
          }
          
        })
      })
      this.map.setCenter(new TMap.LatLng(latlng[0], latlng[1]));
    },
    initMap(){
      var geometries = [];
      this.tabList.map((item, pIndex) => {
        item.list.map((row, index) => {
          let i = index + 1;
          geometries.push({
            id: pIndex + 1 + "" + index,
            styleId: pIndex == 0 && index == 0 ? "myStyle" + i + "on":  "myStyle" + i,
            position: new TMap.LatLng(row.LatLng[0], row.LatLng[1])
          }) 
        })
      })
      this.markerLayer = new TMap.MultiMarker({
          map: this.map, 
          styles: {
              "myStyle1": new TMap.MarkerStyle({ 
                  "width": 34,  
                  "height": 34, 
                  "src": require("./../assets/img/icon_number1_map.png"),
                  "anchor": { x: 12, y: 32 },   
              }),
              "myStyle2": new TMap.MarkerStyle({ 
                  "width": 34,  
                  "height": 34, 
                  "src": require("./../assets/img/icon_number2_map.png"),
                  "anchor": { x: 12, y: 32 },   
              }),
              "myStyle3": new TMap.MarkerStyle({
                  "width": 34,  
                  "height": 34, 
                  "src": require("./../assets/img/icon_number3_map.png"),
                  "anchor": { x: 12, y: 32 },   
              }),
              "myStyle1on": new TMap.MarkerStyle({ 
                  "width": 34,  
                  "height": 34, 
                  "src": require("./../assets/img/icon_number1_on_map.png"),
                  "anchor": { x: 12, y: 32 },   
              }),
              "myStyle2on": new TMap.MarkerStyle({ 
                  "width": 34,  
                  "height": 34, 
                  "src": require("./../assets/img/icon_number2_on_map.png"),
                  "anchor": { x: 12, y: 32 },   
              }),
              "myStyle3on": new TMap.MarkerStyle({
                  "width": 34,  
                  "height": 34, 
                  "src": require("./../assets/img/icon_number3_on_map.png"),
                  "anchor": { x: 12, y: 32 },   
              }),
          },
          geometries: geometries
      });
    }
  },
  destroyed() {
    this.map && this.map.destroy(); 
  },
}
</script>
<style>
.swiper-slide img{
  display: block;
}
.brand-text, .brand-img, .banner-text, .banner-img, .logo-button, .logo-img{
  opacity: 0;
}
@keyframes f {
    0% {
        opacity: 0;
        -webkit-transform: translateY(400px);
        transform: translateY(400px)
    }

    to {
        opacity: 1;
        -webkit-transform: translateY(0);
        transform: translateY(0)
    }
}
@keyframes g {
    0% {
        opacity: 0;
        -webkit-transform: translate(-50%,400px);
        transform: translate(-50%,400px)
    }

    to {
        opacity: 1;
        -webkit-transform: translate(-50%,0);
        transform: translate(-50%,0)
    }
}
@keyframes h {
    0% {
        opacity: 0;
        -webkit-transform: translateY(400px);
        transform: translateY(400px)
    }

    to {
        opacity: 0.68;
        -webkit-transform: translateY(0);
        transform: translateY(0)
    }
}

.block-text {
    -webkit-animation: f 1s ease forwards 0s;
    animation: f 1s ease forwards 0s;
}
.brand-img{
   -webkit-animation: f 1s ease forwards .7s;
    animation: f 1s ease forwards .7s;
}

.brand-text{
  -webkit-animation: f 1s ease forwards 1.4s;
    animation: f 1s ease forwards 1.4s;
}
.banner-text{
  -webkit-animation: h 2s ease forwards 3s;
    animation: h 2s ease forwards 3s;
}
.banner-img{
  -webkit-animation: g 2s ease forwards 2s;
    animation: g 2s ease forwards 2s;
}
.logo-img{
  -webkit-animation: f 1.4s ease forwards 0.7s;
    animation: f 1.4s ease forwards 0.7s;
}
.logo-button{
  -webkit-animation: f 2s ease forwards 1.2s;
    animation: f 2s ease forwards 1.2s;
}

.dots .swiper-pagination-bullet{
    display: inline-block;
    background: #F2EFE8;
    width: 12px;
    height: 12px;
    border-radius: 0;
    opacity: 1;
    cursor: pointer;
}
.dots .swiper-pagination-bullet:focus{
    outline: none;
}
.swiper-pagination-bullet + .swiper-pagination-bullet{
  margin-left: 10px;
}
.dots .swiper-pagination-bullet-active{
    background: #E8DFCA;
    opacity: 1;
}
</style>

<style lang="less" scoped>
.home{
  min-width: 1244px;
  height: 100%;
}
.banner_zindex{
  >div{
    height: 100%;
    width: 470px;
    margin: 0 auto 0;
    padding: 155px 0;
    box-sizing: border-box;
    position: relative;
    >div{
      position: absolute;
      display: block;
      bottom: 0;
      left: 50%;
      width: 4px;
      height: 155px;
      transform: translateX(-50%);
    }
  }
  img{
    display: block;
    margin: 0 auto;
  }
  img:nth-child(2){
    margin-top: 40px;
    cursor: pointer;
  }
  img.taps{
    position: absolute;
    bottom: 165px;
    left: 50%;
    transform: translateX(-50%);
    
  }
  
  .ve-line{
    display: block;
    width: 2px;
    height: 155px;
    background: #FEF9F0;
    bottom: 0;
    left: 50%;
    opacity: .68;
  }
}
.banner__wrapper{
  min-height: 760px;
  .banner-img__wrapper {
    position: absolute;
    width: 1920px;
    min-height: 760px;
    left: 50%;
    margin-left: -960px;
    img{
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -960px;
      width: 1920px;
    }
  }
  .banner__inner {
      position: relative;
      width: 100%;
      overflow: hidden;
      min-height: 760px;
      min-width: 1244px;
    }
}
.channel__wrapper{
  min-height: 515px;
  .channel-img__wrapper {
    position: absolute;
    width: 1920px;
    min-height: 515px;
    left: 50%;
    margin-left: -960px;
    
  }
  .channel__inner {
      position: relative;
      width: 100%;
      overflow: hidden;
      min-height: 515px;
      min-width: 1244px;
    }
}

.box{
  padding: 100px 0 0;
  margin-top: 120px;
  min-width: 1244px;
  .box-title{
    min-width: 1244px;
    img{
      margin: 0 auto;
      display: block;
    }
    
  }
  .title{
    font-size: 36px;
    color: #584339;
    letter-spacing: 5px;
    margin-top: 10px;
    min-width: 1244px;
  }
  .title-en{
    opacity: 0.46;
    font-size: 64px;
    color: #D3CBB7;
    letter-spacing: 0;
    font-family: "宋体";
    font-weight: bold;
    min-width: 1244px;
  }
  h3{
    font-size: 20px;
    color: #333333;
    letter-spacing: 2px;
    line-height: 40px;
  }
  .btn{
    border: 1px solid #B99740;
    width: 285px;
    height: 60px;
    color: #B99740;
    font-size: 18px;
    background: #ffffff;
    display: block;
    margin: 0 auto;
    cursor: pointer;
  }
  .btn:focus{
    outline: none;
  }
}
.brand{
  .brand__inner{
    width: 1200px;
    margin: 85px auto 0;
    overflow: hidden;
    .brand__wrapper{
      width: 462px;
      margin-right: 20px;
      
      h1{
        font-size: 30px;
        color: #333333;
        letter-spacing: 5px;
        margin-bottom: 30px;
      }
      
      ul{
        margin: 40px 0 40px 20px;
        li{
          font-size: 18px;
          color: #666666;
          letter-spacing: 2px;
          list-style-type: disc;
          line-height: 40px;
        }
      }
    }
  }
}

.room{
  h3{
    width: 967px;
    height: 40px;
    margin: 0 auto;
  }
  .room__inner{
    width: 1200px;
    margin: 85px auto 0;
    overflow: hidden;
    position: relative;
    .dots{
      width: 34px;
      overflow: hidden;
      margin: 60px auto;
    }
    .room__img{
       width: 770px;
    }
    .room__img_mini{
      width: 409px;
    }
    .room__shaw{
      z-index: 20;
      position: absolute;
      bottom: 0;
      width: 770px;
      height: 214px;
      background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 3%, rgba(0,0,0,0.25) 17%, #000000 100%);
      padding: 88px 40px;
      box-sizing: border-box;
    }
    .room__shaw_mini{
      z-index: 20;
      position: absolute;
      bottom: 0;
      width: 409px;
      height: 87px;
      background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 3%, rgba(0,0,0,0.25) 17%, #000000 100%);
      padding: 48px 20px;
      box-sizing: border-box;
    }
    h2{
        font-size: 18px;
        color: #FFFFFF;
        letter-spacing: 1.25px;
        line-height: 24px;
      }
      p{
        font-size: 14px;
        color: #FFFFFF;
        letter-spacing: 1.25px;
        line-height: 24px;
      }
  }
}
.meeting{
  .meeting__inner{
    width: 1200px;
    margin: 85px auto 0;
    overflow: hidden;
    .meeting__wrapper{
      width: 462px;
      margin-right: 50px;
      h1{
        font-size: 30px;
        color: #333333;
        letter-spacing: 5px;
        margin-bottom: 30px;
      }
      p{
        margin: 40px auto 70px;
        font-size: 18px;
        color: #666666;
        letter-spacing: 2px;
        line-height: 40px;
      }
    }
  }
}
.celebration{
  
  .celebration__inner{
    width: 1200px;
    margin: 85px auto 0;
    overflow: hidden;
    position: relative;
    .cel__box{
      position: absolute;
      top: 74px;
      font-size: 20px;
      color: #333333;
      letter-spacing: 2px;
      margin-left: 395px;
      z-index: 1;
      p{
        line-height: 40px;
        letter-spacing: 2px;
      }
    }
  }
}
.address{
  .title-en{
    font-size: 40px;
    color: #D3CBB7;
  }
  .title{
    font-size: 38px;
    color: #584339;
  }
  .address__inner{
    position: relative;
    width: 1200px;
    margin: -40px auto 104px;
  }
  .line_left{
    position: absolute;
    left: 0;
    width: 470px;
    height: 1px;
    background: linear-gradient(to left, #D3CBB7, rgba(235, 231,220,.3)); /* 标准的语法 */
  }
  .line_right{
    position: absolute;
    right: 0;
    width: 470px;
    height: 1px;
    background: linear-gradient(to right, #D3CBB7, rgba(235, 231,220,.3)); /* 标准的语法 */
  }
  .map{
    width: 100%;
    height: 525px;
    position: relative;
    #map__inner{
      width: 100%;
      height: 525px;
      position: relative;
    }
  }
}
.map-layer{
    position: absolute;
    top: 50%;
    right: 160px;
    transform: translateY(-50%);
    z-index: 1001;
    width: 360px;
    height: 320px;
    background-color: #fff;
    .map-layer-tabs{
      height: 100%;
      .tabs-wrap{
        height: 40px;
        line-height: 40px;
        color: #999;
        font-size: 18px;
        align-items: center;
        background-color: #f4f5f6;
        border-bottom: 1px solid #876a20;
        .tab-item{
          width: 120px;
          background: #fff;
          color: #333;
          cursor: pointer;
          flex: 1;
          text-align: center;
          position: relative;
        }
        .tab-item-on{
          background-color: #876a20;
          color: #fff;
        }
        
        .tab-item:not(:first-child):before {
            content: "";
            position: absolute;
            left: 0;
            top: 11px;
            width: 1px;
            height: 18px;
            background-color: #ccc;
            box-sizing: border-box;
        }
        .tab-item.tab-item-on+.tab-item:before {
            display: none
        }

        .tab-item.tab-item-on:before{
          height: 0;
        }
      }
      .options-lists {
        li.clicked {
          background-color: #f8f7f2;
          .option-index {
            background-color: #876a20
          }
        }
       
        li:hover {
          background-color: #f8f7f2;
           .option-index {
              background-color: #876a20
          }
        }
        li{
          padding-top: 18px;
          border-bottom: 1px solid #f4f4f4;
          cursor: pointer;
          .option-index {
            text-align: center;
            height: 20px;
            line-height: 20px;
            width: 20px;
            color: #fff;
            background-color: #333
          }
          .option-cont {
            flex: 1;
            padding-left: 16px
          }
          .option-tit {
            font-size: 14px;
            line-height: 19px;
            margin-bottom: 10px
          }
          p {
            padding-bottom: 15px;
            color: #666;
            line-height: 18px;
            font-size: 12px
          }
          .text-desc {
            color: #333
          }
        }
      }

    }
}
</style>

